import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './VenueEditorV2.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes, MainCatalogTypes } from "../../_loadingHelpers/MainCatalogTypes";
import HintBox from '../../../moreCore/UI/HintBox/HintBox';

class VenueEditorV2 extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    ve_Hintbox_Address: MdsLax<InstanceType<typeof HintBox>>;
    ve_Hintbox_AddressRunner: MdsLax<InstanceType<typeof HintBox>>;

    readonlyAddressDataContainer: HTMLElement;
    readonlyAddressRunnerDataContainer: HTMLElement;

    readonlyAddressNote: HTMLTextAreaElement;
    readonlyAddressBuilding: HTMLInputElement;
    readonlyAddressStreet: HTMLInputElement;
    readonlyAddressPostalCode: HTMLInputElement;
    readonlyAddressCity: HTMLInputElement;
    readonlyAddressCountry: HTMLInputElement;

    readonlyAddressRunnerNote: HTMLTextAreaElement;
    readonlyAddressRunnerBuilding: HTMLInputElement;
    readonlyAddressRunnerStreet: HTMLInputElement;
    readonlyAddressRunnerPostalCode: HTMLInputElement;
    readonlyAddressRunnerCity: HTMLInputElement;
    readonlyAddressRunnerCountry: HTMLInputElement;

    isValid(): boolean {
        //Need to implement
        return true;
    }

    afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        this._onChangeHintboxAddressInputData()
        this._onChangeHintboxAddressRunnerInputData()

    }

    _onChangeHintboxAddressInputData(): void {

        let entity: MainCatalogTypes.Venue_HintboxAddressData = this.ve_Hintbox_Address.getValue("entity");

        this.prepareHintboxReadonlyData("Address", entity);

    }

    _onChangeHintboxAddressRunnerInputData(): void {

        let entity: MainCatalogTypes.Venue_HintboxAddressData = this.ve_Hintbox_AddressRunner.getValue("entity");

        this.prepareHintboxReadonlyData("AddressRunner", entity);

    }

    prepareHintboxReadonlyData(hintbox: "Address" | "AddressRunner", entity: MainCatalogTypes.Venue_HintboxAddressData): void {

        switch (hintbox) {
            case "Address":
                if (entity) {

                    this.UiModder.domClass.remove(this.readonlyAddressDataContainer, "w3-hide");

                    this.showHideAddressHintboxDataReadonly(entity.note, this.readonlyAddressNote);
                    this.showHideAddressHintboxDataReadonly(entity.building, this.readonlyAddressBuilding);
                    this.showHideAddressHintboxDataReadonly(entity.street, this.readonlyAddressStreet);
                    this.showHideAddressHintboxDataReadonly(entity.c_postal_code, this.readonlyAddressPostalCode);
                    this.showHideAddressHintboxDataReadonly(entity.c_city, this.readonlyAddressCity);
                    this.showHideAddressHintboxDataReadonly(entity.ref_country?.description, this.readonlyAddressCountry);
                } else {

                    this.UiModder.domClass.add(this.readonlyAddressDataContainer, "w3-hide");

                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressNote);
                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressBuilding);
                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressStreet);
                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressPostalCode);
                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressCity);
                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressCountry);
                }
                break;

            case "AddressRunner":
                if (entity) {

                    this.UiModder.domClass.remove(this.readonlyAddressRunnerDataContainer, "w3-hide");

                    this.showHideAddressHintboxDataReadonly(entity.note, this.readonlyAddressRunnerNote);
                    this.showHideAddressHintboxDataReadonly(entity.building, this.readonlyAddressRunnerBuilding);
                    this.showHideAddressHintboxDataReadonly(entity.street, this.readonlyAddressRunnerStreet);
                    this.showHideAddressHintboxDataReadonly(entity.c_postal_code, this.readonlyAddressRunnerPostalCode);
                    this.showHideAddressHintboxDataReadonly(entity.c_city, this.readonlyAddressRunnerCity);
                    this.showHideAddressHintboxDataReadonly(entity.ref_country?.description, this.readonlyAddressRunnerCountry);
                } else {

                    this.UiModder.domClass.add(this.readonlyAddressRunnerDataContainer, "w3-hide");

                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressRunnerNote);
                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressRunnerBuilding);
                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressRunnerStreet);
                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressRunnerPostalCode);
                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressRunnerCity);
                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressRunnerCountry);
                }
                break;
        }
    }

    showHideAddressHintboxDataReadonly(value: string, node: HTMLTextAreaElement | HTMLInputElement,): void {

        if (value) {

            this.UiModder.domClass.remove(node, "w3-hide");
            this.UiModder.domClass.remove(node.parentElement, "w3-hide");
            node.value = value;
        } else {

            this.UiModder.domClass.add(node, "w3-hide");
            this.UiModder.domClass.add(node.parentElement, "w3-hide");
            node.value = "";
        }
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.Venues;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(VenueEditorV2.prototype, {
  ve_Hintbox_Address: () => (new HintBox()),
  ve_Hintbox_AddressRunner: () => (new HintBox()),
});
export default mdsWidget(VenueEditorV2);